module.exports = __webpack_public_path__ + "img/saturdays_residence.0b8ca2e9.jpg";